import React from "react";
import {BreadCrumbItem} from "../../organisms/HeaderSection";
import Page from "../../organisms/Page";
import CardSection from "./CardSection";

const breadCrumbs: BreadCrumbItem[] = [
    {
        path: "/",
        label: "Inicio"
    },
    {
        path: "/servicios",
        label: "Servicios",
        isActive: true
    }
]

function Servicios(){
    return (
        <Page title="Servicios" description="Visualización, creación y edición de servicios." breadCrumbs={breadCrumbs}>
            <CardSection />
        </Page>
    );
}

export default Servicios;